import { useNavigate } from "react-router-dom";
import { AppLayout } from "../../../layout/AppLayout";
import { Arrow } from "../../../components/svg/Wallet/Wallet";
import { Card } from "../../../components/Card";
import { BaseInput } from "../../../components/input/baseInput";
import Button from "../../../components/button/Button";
import { useState } from "react";
import Select from "../../../components/Select";
import clsx from "clsx";
import {
  BankOutlined,
  Cheveron,
} from "../../../components/svg/worldSvgs/rmc/Achievements";

const banks = [
  { label: "Bank of America", value: "boa" },
  { label: "Chase", value: "chase" },
  { label: "Wells Fargo", value: "wells-fargo" },
  { label: "Citibank", value: "citi" },
  { label: "US Bank", value: "us-bank" },
  { label: "TD Bank", value: "td-bank" },
];

export const Ussd = () => {
  const [bank, setBank] = useState({});
  const navigate = useNavigate();

  return (
    <AppLayout noNav bg={"!bg-[#F8F8F8]"}>
      <div className=" min-h-screen px-4 pt-16">
        <div className="relative flex items-center justify-center">
          <Arrow
            onClick={() => navigate(-1)}
            stroke="#fff"
            className="text-lg absolute left-0 cursor-pointer "
          />
          <p className="font-bold text-xl text-primary-black">USSD Top Up</p>
        </div>
        <Card className="my-12 flex flex-col gap-9">
          <Select
            leadingIcon={
              <div className="mr-3">
                <BankOutlined bgFill="#ECECEC80" fill="#B4B4B4" />{" "}
              </div>
            }
            trailingIcon={<Cheveron stroke="#00000080" className="rotate-90" />}
            options={banks}
            selected={bank}
            setSelected={setBank}
            label="Bank"
            placeholder="Select Bank"
            cheveronClass="!text-[#00000080]"
            selectedOptionClass="bg-[#2741D6] !text-white"
            labelClass="text-primary-black"
            selectedClass={clsx(
              "base_select_selected !bg-[#F8F8F8] !rounded-[50px]",
              bank?.value ? "text-primary-black" : "!text-[#00000080]"
            )}
            dropdownClass="base_select_dropdown !bg-white !shadow-lg "
            optionsClass="base_select_options !text-primary-black hover:!bg-[#2741D6] hover:!text-white"
          />
          <BaseInput
            label="Enter Amount"
            type="number"
            placeholder="500 - 99,999"
            inputClass="bg-[#F8F8F8] !pl-11"
            leadingIcon={<span className="rmc_naira_position">₦</span>}
          />
        </Card>
        <Button
          onClick={() => {}}
          text="Fund Account"
          className="!py-4 !rounded-[50px] "
        />
      </div>
    </AppLayout>
  );
};
